import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { Collection } from 'src/app/models/collection.interface';

export const CollectionFetch = createAction('[Collection] Fetch', props<{ includeHidden: boolean }>());
export const CollectionFetched = createAction('[Collection] Fetched', props<{ collection: Collection[] }>());
export const CollectionError = createAction('[Collection] Error');

export const initialState: CommonApiState<Collection[]> = {
  data: [],
  currentPedingApis: 0,
  isError: false
};

export const collectionFeature = createFeature({
  name: 'collection',
  reducer: createReducer(
    initialState,
    on(CollectionFetch, state => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1
    })),
    on(CollectionFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: result.collection
      };
    }),
    on(CollectionError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),
  extraSelectors: ({ selectCollectionState }) => {
    const collectionIsLoading = createSelector(
      selectCollectionState,
      collectionState => collectionState.currentPedingApis > 0
    );

    //Don't let 2 or more action start another request
    const collectionHasPendingRequest = createSelector(
      selectCollectionState,
      collectionState => collectionState.currentPedingApis >= 2
    );

    return { collectionIsLoading, collectionHasPendingRequest };
  }
});
